import React from 'react';
import { Workbook } from '../../../../types/types';
import Service from '../../../../services/workbooks';
import { withTranslation } from 'react-i18next';

type Props = {
  workbook: Workbook;
  t: any;
};

const Options: React.FC<Props> = ({ workbook, t }) => {
  const handleDeleteClick = () => {
    const confirmMessage = `${t('buttons.delete')} "${workbook.name}"?`;

    if (window.confirm(confirmMessage)) {
      const id = workbook.id.valueOf();
      Service.deleteWorkbook(id)
        .then(() => {
          console.log('Workbook deleted successfully');
          window.location.reload();
        })
        .catch(error => {
          console.error('Error deleting workbook:', error);
        });
    }
  };

  return (
    <div>
      <button className='buttonDelete' onClick={handleDeleteClick}>
        {t("buttons.delete")} {workbook.name}
      </button>
    </div>
  );
};

export default withTranslation("global")(Options);